import React, { useEffect } from 'react'
import Email from 'modules/auth/components/Email'
import { useAppDispatch } from 'store'
import { useSelector } from 'react-redux'
import { selectError } from 'store/slices/auth/selectors'
import { LoginMethod } from '../constants/enums'
import { checkIsRegistered } from 'store/slices/auth/thunks'
import { getCurrentUser } from 'modules/common/helpers'
import { Redirect } from 'react-router-dom'
import { AppRoutes } from 'router/routesConfig'
import { resetAuthStep, clearAsyncMessage } from 'store/slices/auth/slice'

const EmailContainer: React.FC = () => {
  const dispatch = useAppDispatch()
  const error = useSelector(selectError)
  const user = getCurrentUser()

  const handleFormSubmit = (email: string) => {
    dispatch(checkIsRegistered({ loginData: email, loginMethod: LoginMethod.Email }))
  }

  useEffect(() => {
    dispatch(resetAuthStep())

    return () => {
      dispatch(clearAsyncMessage())
    }
  }, [])

  if (user) {
    return <Redirect to={AppRoutes.TIMELINE} />
  }

  return <Email handleFormSubmit={handleFormSubmit} asyncError={error} />
}

export default EmailContainer
